import styled from 'styled-components';

function Benefit() {
  return (
    <Container>
      <Section>
        <Title>참가특전</Title>
        <Content>
          <Card>
            <img src="/assets/images/promotion/seminar/zero-price.svg" alt="" />
            <CardContent>특강 참가비 0원</CardContent>
          </Card>
          <Card>
            <img src="/assets/images/promotion/seminar/time.svg" alt="" />
            <CardContent>2시간 집중 교육</CardContent>
          </Card>
          <Card>
            <img src="/assets/images/promotion/seminar/book.svg" alt="" />
            <CardContent>실습 교재 제공</CardContent>
          </Card>
        </Content>
      </Section>
      <Section>
        <Title>서비스 혜택</Title>
        <Content>
          <Card>
            <img
              src="/assets/images/promotion/seminar/coupon-3day.svg"
              alt=""
              width={263}
            />
            <CardContent>
              스탠다드 전국 3일 무료체험권
              <br />
              (회원 가입 시 무료 체험 3일 제공)
            </CardContent>
          </Card>
          <Card>
            <img
              src="/assets/images/promotion/seminar/coupon-2month.svg"
              alt=""
              width={263}
            />
            <CardContent>
              세미나 한정 혜택 2개월 기간 추가
              <br />
              (1년 스탠다드 결제 시 2개월 기간 추가 쿠폰)
            </CardContent>
          </Card>
        </Content>
      </Section>
    </Container>
  );
}

export default Benefit;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const Title = styled.div`
  color: #0ca8b1;
  font-family: Pretendard;
  font-size: 24px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.48px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 21px;
  align-self: stretch;
`;

const Card = styled.div`
  display: flex;
  width: 100%;
  padding: 40px 20px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(12, 168, 177, 0.2);
`;

const CardContent = styled.div`
  text-align: center;
  color: #2f2e2e;
  font-family: Pretendard;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;
`;
